import BankFailuresSearchForm from "../components/BankFailures/BankFailuresSearchForm";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import * as actions from "../common/actions";
import { getExpandState } from "../common/services/Utilities";
import { All } from "../interfaces";

export function mapStateToProps({ appState }: All) {
  return {
    searchPanelExpand: getExpandState(
      (appState as any)[appState.app].ui.searchPanelExpand,
      true,
    ),
  };
}
function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {

  return {
    setSearchPanelExpand: (updatedSearchPanelExpand: boolean) => {
      dispatch(actions.updateUi("searchPanelExpand", updatedSearchPanelExpand));
      dispatch(actions.searchPush());
    },
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BankFailuresSearchForm);
